import styled from 'styled-components';

export const MainContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
`;

export const ContentContainer = styled.div`
  padding: calc(60px + 16px) 0; 
`;